import React from 'react';

// SVG Icons for Contact Details
const LocationIcon = () => (
  <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
  </svg>
);

const EmailIcon = () => (
  <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
  </svg>
);

const ClockIcon = () => (
  <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
  </svg>
);

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Banner Section */}
      <section className="relative h-[320px] w-full overflow-hidden bg-[#b81d1d] sm:h-[350px]">
        {/* Background Image/Pattern Overlay - Simulating the doctor image on the left */}
        <div 
          className="absolute inset-0 z-0 bg-cover bg-left opacity-30 mix-blend-overlay"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1576091160550-2173ff3e5295?q=80&w=2070&auto=format)' }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#b81d1d] z-0"></div>

        <div className="site-container relative z-10 flex h-full items-center justify-end">
          <div data-aos="fade-left" className="text-right max-w-xl">
            <h1 className="mb-3 text-[34px] font-bold text-white sm:text-[40px] md:text-[52px]">
              Get in Touch
            </h1>
            <p className="text-[14px] font-medium leading-relaxed text-white/90 sm:text-[15px] md:text-[16px]">
              Have questions or need assistance? Our dedicated team is<br className="hidden md:block" />
              here to help you find the perfect vision solution.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <main className="site-container py-14 sm:py-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          
          {/* Left Column: Contact Form */}
          <div data-aos="fade-right" className="lg:col-span-5 relative">
            <div className="relative z-20 -mt-16 rounded-[30px] border border-gray-50 bg-white p-6 shadow-[0_20px_50px_-12px_rgba(0,0,0,0.1)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_25px_60px_-12px_rgba(0,0,0,0.15)] sm:-mt-20 sm:p-8 lg:-mt-24 lg:p-10">
              <h2 className="text-[24px] font-bold text-[#1a1a1a] mb-8">Send us a message</h2>
              
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-[12px] font-bold text-[#1a1a1a]">Full Name</label>
                    <input 
                      type="text" 
                      placeholder="Enter your name" 
                      className="w-full px-4 py-3 rounded-[12px] border border-gray-200 text-[14px] outline-none focus:border-[#2A3182] transition-all duration-300 bg-[#fdfdfd] hover:border-gray-300 focus:-translate-y-0.5 focus:shadow-sm"
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-[12px] font-bold text-[#1a1a1a]">Email Address</label>
                    <input 
                      type="email" 
                      placeholder="Enter your email" 
                      className="w-full px-4 py-3 rounded-[12px] border border-gray-200 text-[14px] outline-none focus:border-[#2A3182] transition-all duration-300 bg-[#fdfdfd] hover:border-gray-300 focus:-translate-y-0.5 focus:shadow-sm"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-[12px] font-bold text-[#1a1a1a]">Phone Number</label>
                    <input 
                      type="tel" 
                      placeholder="Enter your phone" 
                      className="w-full px-4 py-3 rounded-[12px] border border-gray-200 text-[14px] outline-none focus:border-[#2A3182] transition-all duration-300 bg-[#fdfdfd] hover:border-gray-300 focus:-translate-y-0.5 focus:shadow-sm"
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-[12px] font-bold text-[#1a1a1a]">Subject</label>
                    <input 
                      type="text" 
                      placeholder="Enter subject" 
                      className="w-full px-4 py-3 rounded-[12px] border border-gray-200 text-[14px] outline-none focus:border-[#2A3182] transition-all duration-300 bg-[#fdfdfd] hover:border-gray-300 focus:-translate-y-0.5 focus:shadow-sm"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-[12px] font-bold text-[#1a1a1a]">Message</label>
                  <textarea 
                    placeholder="Your message here..." 
                    rows="4"
                    className="w-full px-4 py-3 rounded-[12px] border border-gray-200 text-[14px] outline-none focus:border-[#2A3182] transition-all duration-300 bg-[#fdfdfd] hover:border-gray-300 focus:-translate-y-0.5 focus:shadow-sm resize-none"
                  ></textarea>
                </div>

                <button 
                  type="button" 
                  className="w-full bg-[#353b93] hover:bg-[#2A3182] text-white font-bold py-3.5 rounded-[12px] transition-all duration-300 shadow-md mt-4 text-[15px] hover:-translate-y-0.5 hover:shadow-lg active:scale-[0.98]"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* Right Column: Location & Contact */}
          <div data-aos="fade-left" className="lg:col-span-7 pt-4">
            <h2 className="text-[28px] font-bold text-[#1a1a1a] mb-4">Location & Contact</h2>
            <p className="text-[15px] text-gray-500 font-medium mb-10 max-w-xl leading-relaxed">
              Visit our showroom in New Delhi or contact us through any of our channels. We're always available to help.
            </p>

            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              {/* Card 1: Studio */}
              <div className="bg-[#f8f9fa] hover:bg-white rounded-[16px] p-5 flex items-start gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-md border border-transparent hover:border-gray-100 cursor-default">
                <div className="mt-1">
                  <LocationIcon />
                </div>
                <div>
                  <h4 className="text-[14px] font-bold text-[#1a1a1a] mb-1">Our Studio</h4>
                  <p className="text-[13px] text-gray-500 font-medium leading-relaxed">
                    123 Vision Street, Optical Plaza,<br />New Delhi, India 110001
                  </p>
                </div>
              </div>

              {/* Card 2: Phone */}
              <div className="bg-[#f8f9fa] hover:bg-white rounded-[16px] p-5 flex items-start gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-md border border-transparent hover:border-gray-100 cursor-default">
                <div className="mt-1">
                  <PhoneIcon />
                </div>
                <div>
                  <h4 className="text-[14px] font-bold text-[#1a1a1a] mb-1">Phone Support</h4>
                  <p className="text-[13px] text-gray-500 font-medium">
                    +91 9876543210<br />+91 1234567890
                  </p>
                </div>
              </div>

              {/* Card 3: Email */}
              <div className="bg-[#f8f9fa] hover:bg-white rounded-[16px] p-5 flex items-start gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-md border border-transparent hover:border-gray-100 cursor-default">
                <div className="mt-1">
                  <EmailIcon />
                </div>
                <div>
                  <h4 className="text-[14px] font-bold text-[#1a1a1a] mb-1">Email Support</h4>
                  <p className="text-[13px] text-gray-500 font-medium">
                    optexopticians@gmail.com
                  </p>
                </div>
              </div>

              {/* Card 4: Hours */}
              <div className="bg-[#f8f9fa] hover:bg-white rounded-[16px] p-5 flex items-start gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-md border border-transparent hover:border-gray-100 cursor-default">
                <div className="mt-1">
                  <ClockIcon />
                </div>
                <div>
                  <h4 className="text-[14px] font-bold text-[#1a1a1a] mb-1">Opening Hours</h4>
                  <p className="text-[13px] text-gray-500 font-medium">
                    Mon - Sat: 9:00 AM - 8:00 PM<br />Sun: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="mt-16 h-[320px] w-full overflow-hidden rounded-[24px] border border-gray-100 shadow-sm transition-all duration-500 hover:shadow-lg sm:h-[350px]">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.83923192776!2d77.06889754720782!3d28.52728034389636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x52c2b7494e204dce!2sNew%20Delhi%2C%20Delhi%2C%20India!5e0!3m2!1sen!2sus!4v1614059080000!5m2!1sen!2sus" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map Location"
          ></iframe>
        </div>
      </main>
    </div>
  );
};

export default Contact;
